import {Component} from '@angular/core';

@Component({
  selector: 'guest-layout',
  templateUrl: './component.html',
  styleUrls: ['./../../../admin-styles.scss']
})
export class GuestLayoutComponent {
}
